import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../../auth/service';
import { passwordsMustMatch, UserRegistrationValidators } from '../form-validatation';

@Component({
  selector: 'app-email-verify',
  templateUrl: './email-verify.component.html',
  styleUrl: './email-verify.component.scss'
})
export class EmailVerifyComponent implements OnInit {
  public pageLoading = true;
  public error = '';
  public validated = false;

  // Force password reset flow
  public showResetForm = false;
  private resetToken = '';

  // Form state
  public submitted = false;
  public loading = false;
  public changePasswordSucceeded = false;
  public readonly redirectTimeout = 3;

  public changePasswordForm = this._formBuilder.group({
    password: ['', UserRegistrationValidators.password],
    confirmPassword: ['', Validators.required],
  }, {
    validators: [passwordsMustMatch('password', 'confirmPassword')]
  });

  // Private
  private _onDestroy: Subject<void> = new Subject<void>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _authService: AuthenticationService
  ) {}

  ngOnInit() {
    // Get the resolved data
    const verificationData = this.activatedRoute.snapshot.data['verificationData'];

    // Default verify result UI
    if (verificationData?.message) {
      this.validated = true;
    } else {
      this.validated = false;
    }

    // If backend returned a force reset token, display the reset form instead
    if (verificationData?.force_password_reset_token) {
      this.showResetForm = true;
      this.resetToken = verificationData.force_password_reset_token;
    }

    this.pageLoading = false;
  }

  onSubmit() {
    this.submitted = true;
    this.error = '';

    if (this.changePasswordForm.invalid || !this.resetToken) {
      return;
    }

    this.loading = true;

    const password = this.changePasswordForm.value.password as string;
    const confirmPassword = this.changePasswordForm.value.confirmPassword as string;

    this._authService.resetPassword(password, confirmPassword, this.resetToken)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.error = '';
          this.loading = false;
          this.submitted = false;
          this.changePasswordSucceeded = true;

          setTimeout(() => this._router.navigate(['/login']), this.redirectTimeout * 1000);
        },
        error: (err) => {
          this.loading = false;
          this.submitted = false;
          this.error = err;
        }
      });
  }
}

